import React from 'react'
import { Outlet } from 'react-router-dom'

const SensorsLayout: React.FC = () => {
  return <Outlet />
}

export default SensorsLayout
